import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private userPermissions: string[] = [];
  private isAdmin = false;
  
  setUser(user: any) {
    this.userPermissions = Array.isArray(user?.role?.permissions) ? user.role.permissions : [];
    this.isAdmin = (user?.role?.name || '').toLowerCase() === 'admin';
  }

  hasPermission(required: string[] = []): boolean {
    if (this.isAdmin) return true;                       // admin always allowed
    if (!required || required.length === 0) return true; // no specific requirement
    if (required.length === 1) {
      return required.some(p => this.userPermissions.includes(p));
    } else {
      return required.every(p => this.userPermissions.includes(p));
    }
  }
   // required will be array of permissions, if any one exists in user permissions, it will return true
  hasAnyPermission(required: string[] = []): boolean {
    if (this.isAdmin) return true;
    return required.some(p => this.userPermissions.includes(p));
  }
}
